var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8462 0H1.15387C0.847847 0 0.554362 0.131696 0.337974 0.366116C0.121586 0.600537 2.08949e-05 0.918479 2.08949e-05 1.25V13.75C-0.00130969 13.9884 0.0609343 14.2221 0.179271 14.423C0.297607 14.624 0.467 14.7836 0.667087 14.8828C0.81956 14.9597 0.985674 14.9997 1.15387 15C1.42472 14.9992 1.68658 14.8946 1.89305 14.7047L1.89954 14.6992L4.25482 12.5H13.8462C14.1522 12.5 14.4457 12.3683 14.662 12.1339C14.8784 11.8995 15 11.5815 15 11.25V1.25C15 0.918479 14.8784 0.600537 14.662 0.366116C14.4457 0.131696 14.1522 0 13.8462 0ZM13.8462 11.25H4.03848C3.89995 11.2501 3.76607 11.3042 3.66131 11.4023L1.15387 13.75V1.25H13.8462V11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChat);
export default __webpack_public_path__ + "static/media/newChat.656f6feaea52fe407d768a52062bf0a8.svg";
export { ForwardRef as ReactComponent };